import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { PositiveIcon } from "../../../../common/icons";
import { injectIntl, defineMessages, FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { UploadFileConclusionBase } from "../../../../components/single-registry/upload/UploadFileConclusion/UploadFileConclusion";
import { styles } from "../../../../components/single-registry/upload/UploadFileConclusion/UploadFileConclusion.styles";
import { translations } from "./constants";
import HUBContext from "../../../../services/HUBContext";
import { ROUTER_MAP_PATH } from "../../../../EmbeddedRoutes";

const messages = defineMessages(translations);

class UploadFileConclusionWidget extends UploadFileConclusionBase {
  render() {
    const { classes, itemsChanged, hasSolutions, intl } = this.props;
    const { company } = this.context;

    return (
      <div className={classes.container}>
        <div className={classes.innerContainer}>
          <div className={classes.headerSection}>
            <div className={classes.iconWrapper}>
              <div className={classes.checkIcon}>
                <PositiveIcon />
              </div>
              <span className={classes.statusText}>
                {intl.formatMessage(messages.status)}
              </span>
            </div>

            <h1 className={classes.title}>
              {intl.formatMessage(messages.title)}
            </h1>
            <p className={classes.subtitle}>
              {intl.formatMessage(messages.subtitle)}
              {hasSolutions && (
                <>
                  <br />
                  <FormattedMessage
                    {...messages.followProgress}
                    values={{
                      link: (
                        <Link
                          to={ROUTER_MAP_PATH.vehicles.syncHistoryPage?.replace(
                            ":cid",
                            company?.companyID,
                          )}
                          className={classes.link}
                        >
                          {intl.formatMessage(messages.nextStepLinkText)}
                        </Link>
                      ),
                    }}
                  />
                </>
              )}
            </p>

            <div className={classes.badge}>
              <FormattedMessage
                {...messages.itemsChanged}
                values={{ items: itemsChanged }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UploadFileConclusionWidget.contextType = HUBContext;

export default withStyles(styles)(injectIntl(UploadFileConclusionWidget));
